module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_boxes_small-6ece8fa57d1c39530ab780bbda5623ee.svg";